import React, { useMemo } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./calendar.css";

import es from "date-fns/locale/es"; // ✅ español
registerLocale("es", es);

// yyyy-mm-dd desde Date
const dateToISO = (date) => {
  if (!date) return "";
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const Calendar = ({ selectedDateObj, onChangeDate, datesWithForms = [], maxDate = new Date() }) => {
  // ✅ el backend ya manda las fechas (ISO) que tienen formularios — ya no
  // hace falta traer/derivar de la tabla completa en el frontend.
  const daysWithForms = useMemo(() => new Set(datesWithForms || []), [datesWithForms]);

  return (
    <div className="qs-cal">
      <DatePicker
        inline
        locale="es"                 // ✅ español
        selected={selectedDateObj}
        onChange={(date) => onChangeDate(date)}
        maxDate={maxDate}
        calendarStartDay={1}        // ✅ semana inicia lunes
        calendarClassName="qs-cal-calendar"
        dayClassName={(date) => {
          const iso = dateToISO(date);
          return daysWithForms.has(iso) ? "qs-cal-day qs-cal-has" : "qs-cal-day";
        }}
      />

      <div className="qs-cal-legend">
        <span className="qs-cal-dot qs-cal-dot-has" /> Con formularios
        <span className="qs-cal-dot qs-cal-dot-empty ms-3" /> Sin formularios
      </div>
    </div>
  );
};

export default Calendar;